/** Signature of a logging function */
export interface LogFn {
    (message?: any, ...optionalParams: any[]): void;
}

/** Basic logger interface */
export interface ILogger {
    log: LogFn;
    debug: LogFn;
    info: LogFn;
    warn: LogFn;
    error: LogFn;
}

//https://meticulous.ai/blog/getting-started-with-react-logging/
//https://dev.to/rajeshroyal/reactjs-disable-consolelog-in-production-and-staging-3l38

/** Log levels */
export type LogLevel = 'log' | 'warn' | 'error';

/** Logger which outputs to the browser console */
export class Logger implements ILogger {
    constructor(private name: string, options?: { level?: LogLevel }) {

    }
    log(message?: any, ...optionalParams: any[]): void {
        console.log(`[${this.name} -  ${Date.now().toLocaleString()}] ${message}`, ...optionalParams);
    }

    warn(message?: any, ...optionalParams: any[]): void {
        console.warn(`[${this.name} -  ${Date.now().toLocaleString()}] ${message}`, ...optionalParams);
    }

    error(message?: any, ...optionalParams: any[]): void {
        console.error(`[${this.name} -  ${Date.now().toLocaleString()}] ${message}`, ...optionalParams);
    }

    debug(message?: any, ...optionalParams: any[]): void {
        if (process.env.NODE_ENV === "production" ||
            process.env.REACT_APP_ENV === "STAGING" || (process.env.NODE_ENV || '').toLowerCase().startsWith('prod')) {
            return;
        }
        console.debug(`[${this.name} -  ${Date.now().toLocaleString()}] ${message}`, ...optionalParams);
    }

    info(message?: any, ...optionalParams: any[]): void {
        console.info(`[${process.env.NODE_ENV}] [${this.name} -  ${Date.now().toLocaleString()}] ${message}`, ...optionalParams);
    }
}